import { useEffect } from 'react';
import { useBrand } from '@/features/auth/useAuth';
import { appliquerCouleursMarque, memoriserCouleursMarque } from '@/lib/couleurs-marque';

/**
 * Applique les couleurs de la marque à toute l'application dès qu'elles sont
 * connues, page de connexion comprise, puis à chaque changement. Elles sont
 * aussi retenues pour être posées dès le prochain chargement, avant la réponse
 * de l'API (voir `main.tsx`). Ne rend rien.
 */
export function CouleursMarque() {
  const { data: marque } = useBrand();
  useEffect(() => {
    appliquerCouleursMarque(marque);
    memoriserCouleursMarque(marque);
  }, [marque]);
  return null;
}
